<template>
  <section class="dapp">
    <div class="dapp-con">
      <div class="dapp-img">
        <div class="imgbox">
          <img class="img2" src="../../assets/img/Mockup7@2x.png" />
        </div>
        <div class="imgbox dappImg" :class="{ move:anime }">
          <img class="img1" src="../../assets/img/Mockup6@2x.png" />
        </div>
      </div>
      <div class="content">
        <h2>{{ $t('overview.dapps.title') }}</h2>
        <p>{{ $t('overview.dapps.desc') }}</p>
        <img src="../../assets/img/pic_dapp_icon.svg" />
        <!-- <svg version="1.1"
          preserveAspectRatio="xMinYMin meet"
          width="164" height="51"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <image xlink:href="../../assets/img/pic_dapp_icon.svg" width="164" height="51"/>
        </svg> -->
        <span>{{ $t('overview.dapps.remark') }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      imgNum: 0,
      imgElNum: 0,
      anime: false
    }
  },
  methods: {
    computImg () {
      this.imgNum += 1
      if (this.imgElNum === 0) {
        return false
      }
      if (this.imgNum === this.imgElNum) {
        this.mountAnime()
      }
    },
    mountAnime () {
      window.sr.reveal('.dappImg', {
        viewFactor: .3,
        scale: 1,
        duration: 0,
        origin: 'left',
        distance: '0',
        easing: 'ease-in',
        opacity: 1,
        delay: 0,
        afterReveal: () => {
          this.anime = true
        },
      })
    }
  },
  mounted () {
    let imgs = this.$el.getElementsByTagName('img')
    this.imgElNum = imgs.length
    for (let i = 0; i < imgs.length; i++) {
      let src = imgs[i].src
      imgs[i].src = ''
      imgs[i].addEventListener('load', () => {
        this.computImg()
      })
      imgs[i].src = src
    }
  }
}
</script>

<style lang="css" scoped>
.dapp {
  background-color: #161616;
}
.dapp-con {
  max-width: 1200px;
  margin: auto;
  padding: 120px 20px 0;
  position: relative;
  display: flex;
  flex: 1;
  overflow: hidden;
  justify-content: center;
}
.dapp-img {
  width: auto;
  max-width: 620px;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  align-items: flex-end;
  flex: 1;
  /* margin-left: -89px */
}
.dapp-img .imgbox {
  width: auto;
  font-size: 0;
  transition: all .3s linear;
}

.move {
  transform: translateX(0) !important;
}

.dapp-img .imgbox:nth-child(1) {
  max-width: 315px;
}
.dapp-img .imgbox:nth-child(2) {
  max-width: 370px;
  margin-left: -196px;
  transform: translateX(-110px);
  transition-delay: .1s
}
.dapp-img img {
  width: 100%;

}
.dapp-con .content {
  color: #fff;
  max-width: 450px;
  padding: 0 0 252px 72px ;
}

.dapp-con .content h2 {
  margin-top: 62px;
  font-size: 40px;
  line-height: 48px;
}

.dapp-con .content p {
  font-size: 16px;
  line-height: 32px;
  margin: 19px 0 56px;
}

.dapp-con .content span {
  display: block;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
}
.img-wrapper {
  max-height: 588px;
  height: 60vw;
  position: relative;
}

@media screen and (max-width: 1000px) {
  .dapp-img {
    margin-left: 0;
  }
}

@media screen and (max-width: 768px) {
  .dapp-con {
    flex-direction: column-reverse;
    padding: 56px 38px 0;
  }
  .dapp-con .content{
    text-align: center;
    max-width: 100%;
    width: 100%;
    margin: 0 0 49px;
    padding-left: 0;
    padding-bottom: 0;
  }
  .dapp-con .content h2 {
    margin-top: 0;
  }
  .dapp-con .content p {
    margin-bottom: 32px;
    margin-top: 15px;
  }
  .dapp-con .dapp-img {
    margin: auto;
  }
  .dapp-img .imgbox:nth-child(2) {
    transform: translateX(-75px);
  }
}
</style>